<app-side-menu>
  <div class="bank-statements-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-invoice-dollar me-3"></i>
                Extratos Bancários
              </h1>
              <p class="page-subtitle">Visualize extratos por banco e período</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bank-statements-card">
          <div class="filters-section">
            <div class="filters-row">
              <div class="filter-group">
                <label class="form-label">Banco:</label>
                <input type="text" class="form-control" [(ngModel)]="selectedBank" (change)="onBankChange(selectedBank)" placeholder="Ex.: Bradesco"/>
              </div>
              <div class="filter-group">
                <label class="form-label">Período:</label>
                <div class="d-flex gap-2">
                  <input type="date" class="form-control" [(ngModel)]="startDate" (change)="onDateRangeChange()"/>
                  <span class="align-self-center">até</span>
                  <input type="date" class="form-control" [(ngModel)]="endDate" (change)="onDateRangeChange()"/>
                </div>
              </div>
              <div class="filter-actions">
                <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
                  <i class="fas fa-times me-2"></i>
                  Limpar Filtros
                </button>
                <button type="button" class="btn btn-primary ms-2" (click)="openNew()">
                  <i class="fas fa-plus me-2"></i>
                  Novo
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="showForm" class="mt-3">
            <div class="card p-3">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">Banco</label>
                  <input type="text" class="form-control" [(ngModel)]="formData.bankName"/>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Data</label>
                  <input type="date" class="form-control" [(ngModel)]="formData.statementDate"/>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Saldo Inicial</label>
                  <input type="number" class="form-control" [(ngModel)]="formData.openingBalance"/>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Saldo Final</label>
                  <input type="number" class="form-control" [(ngModel)]="formData.closingBalance"/>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-outline-secondary me-2" (click)="cancelForm()">Cancelar</button>
                <button type="button" class="btn btn-success" (click)="submitForm()">{{ editMode ? 'Salvar' : 'Criar' }}</button>
              </div>
            </div>
          </div>

          <div *ngIf="!loading && !error && statements.length > 0" class="table-content">
            <app-table
              [title]="tableTitle"
              [columns]="columns"
              [data]="statements"
              [loading]="loading"
              [showSearch]="showSearch"
              [searchPlaceholder]="searchPlaceholder"
              [clickable]="clickable"
              [actions]="actions"
              [enableSorting]="true"
              [clientSideSort]="true"
              (actionClick)="onActionClick($event)"
              (searchChange)="onSearch($event)"
              (rowClick)="onRowClick($event)">
            </app-table>
          </div>

          <div *ngIf="!loading && !error && statements.length === 0" class="empty-state">
            <i class="fas fa-file-invoice-dollar"></i>
            <h3>Nenhum extrato encontrado</h3>
            <p>Informe um banco e período para listar os extratos.</p>
          </div>

<div *ngIf="error" class="alert alert-danger" role="alert">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
